{
	"title": "Materiales disponibles",
	"showAllTitle": "Mostrar todos los materiales",
	"table": {
		"material": "Material",
		"invoicedQuantity": "Cantidad facturada",
		"remainingForTransfer": "Restante para la creación de la declaración",
		"fetchError": "No se pudieron recuperar los materiales",
		"noMaterials": {
			"title": "No hay materiales disponibles",
			"description": "Actualmente no tiene materiales disponibles en el {{productName}}. Comuníquese con su representante de ventas para agregar su(s) contrato(s) a su cuenta."
		}
	}
}
